module.exports = __webpack_public_path__ + "static/fun-icon2-71207635491ae46a5ad0b60cd7b562e5.png";